export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <rect x="1.91603" y="10.878" width="26.1679" height="18.0074" rx="1.44168" stroke="white" strokeWidth="2.12173" />
            <path
                d="M7.22038 9.81721V9.68489C7.22038 5.25106 10.8147 1.65674 15.2485 1.65674V1.65674C19.6824 1.65674 23.2767 5.25106 23.2767 9.68489V9.81721"
                stroke="white"
                strokeWidth="2.12173"
            />
            <circle cx="15" cy="18.4404" r="2.12172" stroke="white" strokeWidth="2.12173" />
            <path
                d="M13.9391 25.2136C13.9391 25.7995 14.4141 26.2744 15 26.2744C15.5859 26.2744 16.0609 25.7995 16.0609 25.2136H13.9391ZM13.9391 20.8613V25.2136H16.0609V20.8613H13.9391Z"
                fill="white"
            />
        </svg>
    );
}
